import { render, staticRenderFns } from "./material-list.vue?vue&type=template&id=0c96af48&scoped=true"
import script from "./material-list.vue?vue&type=script&setup=true&lang=js"
export * from "./material-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-list.vue?vue&type=style&index=0&id=0c96af48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96af48",
  null
  
)

export default component.exports